<template>
  <div class="pin" :model="searchForm" v-loading="loading">
    <el-page-header
      @back="handleBack('home')"
      content="订单管理"
    ></el-page-header>
    <el-form :inline="true" style="margin-top: 10px">
      <el-form-item>
        <el-date-picker
          v-model="searchForm.time"
          size="mini"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="searchForm.orderStatus"
          size="mini"
          placeholder="订单状态"
          clearable
        >
          <el-option
            v-for="item in orderStatusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" type="primary" @click="leaderLsit"
          >查询</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button size="mini" type="primary" @click="handleBack('card')"
          >课程卡印制</el-button
        >
      </el-form-item>
      <!-- <el-form-item>
        <el-button size="mini" type="primary" icon="el-icon-back" @click="handleBack('home')">返回</el-button>
      </el-form-item> -->
    </el-form>
    <el-table
      :data="tableData"
      border
      stripe
      style="width: 100%; margin-top: 10px"
      highlight-current-row
    >
      <el-table-column type="index" align="center"></el-table-column>
      <el-table-column
        prop="orderCode"
        label="订单编号"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="schoolName"
        label="学校名称"
        align="center"
      ></el-table-column>
      <el-table-column
        label="课程卡数量"
        align="center"
        prop="printNum"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="noticeName"
        label="订单状态"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.orderStatus == 1
              ? '待发货'
              : scope.row.orderStatus == 2
              ? '待发货'
              : scope.row.orderStatus == 3
              ? '待发货'
              : scope.row.orderStatus == 4
              ? '待签收'
              : '已签收'
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="下单时间"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          {{ scope.row.createTime.slice(0, 10) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="hopeSendTime"
        label="预计送达学校时间"
        align="center"
        width="130"
      >
        <template slot-scope="scope">
          {{ scope.row.hopeSendTime.slice(0, 10) }}
        </template></el-table-column
      >
      <!-- <el-table-column
        prop="creatorAccount"
        label="下单账号"
        align="center"
      ></el-table-column> -->
      <!-- <el-table-column label="订单详情" align="center">
        <template slot-scope="scope">
          <el-button @click="chal(scope.row.id)" type="text">查看</el-button>
        </template>
      </el-table-column> -->
      <el-table-column label="物流信息" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="checkLogistics(scope.row)">{{
            scope.row.logisticsCode
          }}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="100">
        <template slot-scope="scope">
          <!-- <el-button
            type="text"
            :disabled="scope.row.orderStatus !== 1"
            @click="cancelOrder(scope.row.id)"
            >取消订单</el-button
          > -->
          <el-button @click="chal(scope.row.id)" type="text"
            >订单详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page.sync="pageNum"
      @prev-click="gai"
      @next-click="gai"
      @current-change="gai"
      :hide-on-single-page="true"
      background
      layout="total,prev, pager, next"
      style="margin-top: 15px; float: right"
      :total="totalCount"
    ></el-pagination>
    <el-dialog title="物流信息" :visible.sync="dialogVisible3" width="800px">
      <div style="margin-bottom: 15px">{{ activities.company }}</div>
      <div style="margin-bottom: 15px">
        <el-radio-group v-model="reverse">
          <el-radio :label="true">时间倒序</el-radio>
          <el-radio :label="false">时间正序</el-radio>
        </el-radio-group>
      </div>
      <el-timeline :reverse="reverse">
        <el-timeline-item
          v-for="(activity, index) in activities.logisticsDetailVoList"
          :key="index"
          :timestamp="activity.time"
        >
          {{ activity.context }}
        </el-timeline-item>
      </el-timeline>
    </el-dialog>
  </div>
</template>

<script>
import * as homeApi from '@/api/observation'
// import store from "@/store";
export default {
  components: {},
  data() {
    return {
      pageNum: 1,
      tableData: [],
      totalCount: 0,
      schoolId: '',
      schoollist: [],
      src: '',
      dialogVisible: false,
      dialogVisible3: false,
      activities: [],
      reverse: false,
      loading: false,
      searchForm: {
        time: [],
      }, //查询参数
      orderStatusOptions: [
        {
          label: '待接单',
          value: 1,
        },
        {
          label: '已取消',
          value: 2,
        },
        {
          label: '待发货',
          value: 3,
        },
        {
          label: '待签收',
          value: 4,
        },
        {
          label: '已签收',
          value: 5,
        },
      ], //订单状态
    }
  },
  watch: {},
  methods: {
    checkLogistics(s) {
      let that = this
      that.loading = true
      let params = {
        logisticsCode: s.logisticsCode,
      }
      homeApi
        .checkLogistics(params)
        .then((res) => {
          that.activities = res.data.data
          that.dialogVisible3 = true
          that.loading = false
        })
        .catch(() => {
          that.loading = false
        })
    },
    gai(s) {
      this.pageNum = s
      this.queryCardPrintOrderList()
    },
    queryCardPrintOrderList() {
      let that = this
      let params = {
        pageNum: this.pageNum,
        pageSize: 10,
        orderStatus: this.searchForm.orderStatus,
        beginTime: this.searchForm.time ? this.searchForm.time[0] : undefined,
        endTime: this.searchForm.time ? this.searchForm.time[1] : undefined,
      }
      that.loading = true
      homeApi
        .querySchoolCardPrintOrderList(params)
        .then((res) => {
          that.tableData = res.data.data.dataList
          that.totalCount = res.data.data.totalCount
          that.loading = false
        })
        .catch(() => {
          that.loading = false
        })
    },
    goBack() {
      this.$emit('navlink', 'bazaar_customization')
    },
    chal(s) {
      localStorage.setItem('ddid', s)
      localStorage.setItem('isdk', 1)
      this.$emit('backBench', 'orderDetail')
      // this.$emit("navlink", "bazaar_particulars");
    },
    cancelOrder(s) {
      this.$confirm('是否确定取消订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let that = this
          let params = {
            orderId: s,
          }
          homeApi
            .cancelOrder(params)
            .then((res) => {
              that.$message({
                type: 'success',
                message: '取消成功!',
              })
              that.queryCardPrintOrderList()
            })
            .catch(() => {})
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    cha(s) {
      this.dialogVisible = true
    },
    leaderLsit() {
      console.log(this.searchForm)
      this.queryCardPrintOrderList()
    },
    //返回
    handleBack(val) {
      console.log('订单', val)
      this.$emit('backBench', val)
    },
  },
  components: {},
  mounted() {
    this.queryCardPrintOrderList()
  },
}
</script>

<style lang='less' scoped>
.pin {
  box-sizing: border-box;
  background: #fff;
  padding: 10px;
  height: 100%;
}
/deep/ .el-form-item {
  margin: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/bench/components/order.vue